// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'molitorBold', 'molitorBold Fallback'","fontWeight":800,"fontStyle":"normal"},"className":"__className_1e54c3","variable":"__variable_1e54c3"};